import { Box, Typography, Button, Grid, Container, Divider, Tab, Checkbox } from '@mui/material'

import React, { useEffect, useState } from 'react'
import Carousel from 'react-material-ui-carousel'
import WTypography from 'Components/whiteTypography'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'
import { useParams, useNavigate } from 'react-router-dom'
import { UTILISATION } from 'utils/constants'
import CustomButton from 'Components/CustomButton/CustomButton'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'

import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'

import Link from '@mui/material/Link'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import AttachmentIcon from '@mui/icons-material/Attachment'
import CreateDocumentsForm from 'Components/CreateDocumentsForm'

import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'

import EditIcon from '@mui/icons-material/Edit'

import CreateOperationForm from './CreateOperationForm'
import DoneOperationForm from './DoneOperationForm'
import ListOperationsRealiser from './ListOperationsRealiser'
import ListOperationsHistoriques from './ListOperationsHistoriques'
import EditOperationForm from './EditOperationForm'
import CreateEventForm from './CreateEventForm'
import EventViewForm from './EventViewForm'
import { convertToUserDateFormate } from 'utils/helpers'
import { useSelector } from 'react-redux'

export const EntretienDetails = () => {
  const siteUser = useSelector((store) => store.user)

  const { id } = useParams()
  const [entretien, setEntretien] = useState({})
  const [value, setValue] = React.useState('1')

  const [operations, setOperations] = useState({})
  const [operationsH, setOperationsH] = useState({})
  const [selectedRowsParams, setSelectedRowsParams] = useState({})
  const [selectedRows, setSelectedRows] = useState([])

  const [doneF, setDoneF] = useState(0)
  const [eventF, setEventF] = useState(false)
  const [eventViewF, setEventViewF] = useState(false)
  const [loading, setLoading] = useState(false)
  const [selected, setSelected] = useState(false)

  let navigate = useNavigate()

  useEffect(() => {
    fetchEntretienDetail()
    fetchEntretienHistoriques()
    fetchOperations()
  }, [])

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const fetchEntretienDetail = async () => {
    const response = await makeGetRequest(urls.crudEntretienOperations + id, {}, true)
    if (response.status === 200) {
      setEntretien(response.data)
    }
  }
  const fetchOperations = async (pagination = '') => {
    setLoading(true)
    let url = `${
      urls.crudEntretienRealiserOperations + `?IdMaintenanceplan=${id}&Done=false&page=maintenance`
    }`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperations({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }
  const fetchEntretienHistoriques = async (pagination = '') => {
    setLoading(true)
    let url = `${
      urls.crudEntretienRealiserOperations + `?IdMaintenanceplan=${id}&Done=true&page=maintenance`
    }`

    if (pagination !== '') {
      url += pagination
    }
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setOperationsH({ ...response.data })
      setLoading(false)
    }
    setLoading(false)
  }
  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const filteredOperations = operations.results.filter((v) => selectedRows.indexOf(v.id) === -1)
      setOperations({
        ...operations,
        results: filteredOperations,
        count: operations.count - selectedRows.length,
      })
      const response = await makePostRequest(
        urls.deleteBulkOperationM,
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
  }
  const displayColumn = (name, value, postfix = '', Icone = '') => (
    <Box>
      {name === 'Statut' ? (
        <Typography
          variant="h6"
          sx={{
            color: value === 'actif' ? 'green' : value === 'désactivé' ? 'red' : 'unset',
          }}
        >
          {value}
        </Typography>
      ) : (
        <WTypography variant="h6">
          {value || 'N/A'} {postfix || ''}
        </WTypography>
      )}
      {Icone ? (
        <Typography color="secondary">
          {name} <Icone />
        </Typography>
      ) : (
        <Typography color="secondary">{name}</Typography>
      )}
    </Box>
  )

  const informationGenerales = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <WTypography variant="h6">Informations générales</WTypography>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        <Box>
          {displayColumn(
            'Date de création',
            convertToUserDateFormate(siteUser.user, entretien.CreationDate),
          )}
        </Box>
        {entretien.EquipementType === 'Véhicules' && (
          <>
            <Box>{displayColumn('Immatriculation', entretien.Identification)}</Box>
            <Box>{displayColumn('Kilométrage', entretien.Mileage, 'Km')}</Box>
            <Box>{displayColumn('Kilométrage moyen', entretien.AverageMileage, 'Km/mois')}</Box>
          </>
        )}
        {entretien.EquipementType === 'Immobilier' && (
          <>
            <Box>{displayColumn('Immatriculation', entretien.EquipementCarac)}</Box>
            <Box></Box>
            <Box></Box>
            <Box></Box>
          </>
        )}
        {entretien.EquipementType === 'Autres' && (
          <>
            <Box>{displayColumn("Type d'équipement", entretien.EquipementType)}</Box>
            <Box>{displayColumn('Sous Type équipement', entretien.EquipementSubType)}</Box>
            <Box>{displayColumn('Caractéristique', entretien.EquipementCarac)}</Box>
          </>
        )}
      </Box>
      <Box display={'flex'} flexWrap="wrap" justifyContent={'space-between'} px={4} py={1}>
        {entretien.EquipementType === 'Véhicules' && (
          <>
            <Box>
              {displayColumn(
                'Mise en circulation',
                convertToUserDateFormate(siteUser.user, entretien.DatePremCirculation),
              )}
            </Box>
            <Box>{displayColumn('Age', entretien.Age, 'ans')}</Box>
            <Box>
              {displayColumn('Budget prévisionnel annuel', entretien.MaintenanceBudget, '€')}
            </Box>
          </>
        )}
        {entretien.EquipementType === 'Immobilier' && (
          <>
            <Box>
              {displayColumn(
                "Date d'entrée",
                convertToUserDateFormate(siteUser.user, entretien.immobiliers?.created_at),
              )}
            </Box>
            <Box>{displayColumn('Age', entretien.Age, 'ans')}</Box>
            <Box>
              {displayColumn('Budget prévisionnel annuel', entretien.MaintenanceBudget, '€')}
            </Box>
            <Box>
              {displayColumn(
                'Date sortie',
                convertToUserDateFormate(siteUser.user, entretien.ExitDate),
              )}
            </Box>
          </>
        )}
        {entretien.EquipementType === 'Autres' && (
          <>
            <Box>{displayColumn('Age', entretien.Age, 'ans')}</Box>
            <Box>
              {displayColumn('Budget prévisionnel annuel', entretien.MaintenanceBudget, '€')}
            </Box>
            <Box>{displayColumn('Statut', entretien.Statut)}</Box>
          </>
        )}
      </Box>
    </Box>
  )

  const oeprationsRealiser = (
    <Container maxWidth="xl">
      <Box justifyContent="flex-end" paddingBottom="60px" display="flex">
        <Box>
          <CustomButton
            onClick={() => {
              if (selectedRows.length === 1) {
                let srow = operations.results.filter((v) => v.id === selectedRows[0])
                setSelectedRowsParams(srow[0])
                setEventF(srow[0])
              } else {
                setSelected(false)
                alert('Please Select one document for planifier')
              }
            }}
          >
            planifier
          </CustomButton>
          <CreateOperationForm setOperations={setOperations} eid={id} />
          <CustomButton
            onClick={() => {
              if (selectedRows.length === 1) {
                setSelectedRowsParams({
                  ...operations.results.filter((v) => v.id === selectedRows[0]),
                })
                setSelected(true)
              } else {
                setSelected(false)
                alert('Please Select one document for modifier')
              }
            }}
          >
            Modifier
          </CustomButton>
          {selected ? (
            <EditOperationForm
              setOperations={setOperations}
              params={selectedRowsParams}
              operations={operations}
              setSelected={setSelected}
            />
          ) : (
            ''
          )}

          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>

      <ListOperationsRealiser
        fetchOperations={fetchOperations}
        setSelectedRows={setSelectedRows}
        setDoneF={setDoneF}
        setEventF={setEventF}
        setEventViewF={setEventViewF}
        operations={operations}
      />
    </Container>
  )

  const historiques = (
    <Container maxWidth="xl">
      <ListOperationsHistoriques
        fetchOperations={fetchEntretienHistoriques}
        setSelectedRows={setSelectedRows}
        operations={operationsH}
      />
    </Container>
  )

  const documents = (
    <Box border={'1px solid darkgrey'} borderRadius={1} p={1} mt={2}>
      <BasicTable />
    </Box>
  )

  return (
    <>
      {doneF > 0 && (
        <DoneOperationForm
          setDoneF={setDoneF}
          setOperations={setOperations}
          operations={operations}
          oid={doneF}
        />
      )}
      {eventF && (
        <CreateEventForm setEventF={setEventF} fetchOperations={fetchOperations} row={eventF} />
      )}
      {eventViewF && <EventViewForm setEventViewF={setEventViewF} row={eventViewF} />}
      <Container maxWidth="lg">
        {entretien.EquipementType === 'Véhicules' && entretien.vehicle && (
          <>
            <Box display={'flex'} alignItems={'center'} px={4} py={1}>
              <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                width="240px"
                height="180px"
              >
                <img
                  key="carLogo"
                  src={entretien.vehicules.Models?.carpicture}
                  alt="img"
                  // width="240px"
                  // height="180px"
                />
              </Box>
              <Box
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'center'}
                width="100%"
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                  marginLeft="20px"
                >
                  <WTypography
                    onClick={() => navigate(`/domicile/vehicule/${entretien.vehicle}`)}
                    variant="h6"
                    sx={{ textDecoration: 'underline', color: '#fff' }}
                  >
                    {entretien.vehicules.Name}
                  </WTypography>
                  <WTypography variant="h6">
                    {entretien.vehicules?.Motortypes?.motor_type}
                  </WTypography>

                  <Typography color="secondary">Plan d’entretien</Typography>
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: entretien.Statut === 'actif' ? 'green' : 'red',
                    }}
                  >
                    {entretien.Statut}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </>
        )}

        {entretien.EquipementType === 'Immobilier' && entretien.immobilier && (
          <>
            <Box display={'flex'} alignItems={'center'} px={4} py={1}>
              <Box
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                width="240px"
                height="180px"
              >
                <img
                  key="carLogo"
                  src={entretien.immobiliers?.pictures[0]?.picture}
                  alt="img"
                  // width="240px"
                  // height="180px"
                />
              </Box>
              <Box
                display={'flex'}
                justifyContent={'space-between'}
                alignItems={'center'}
                width="100%"
              >
                <Box
                  display="flex"
                  justifyContent="center"
                  flexDirection="column"
                  marginLeft="20px"
                >
                  <WTypography
                    variant="h6"
                    onClick={() =>
                      navigate(`/domicile/monimmobilier/monbien/${entretien.immobilier}`)
                    }
                    sx={{ textDecoration: 'underline', color: '#fff' }}
                  >
                    {entretien.immobiliers?.nom}
                  </WTypography>
                  <WTypography variant="h6">
                    {entretien.immobiliers?.type_de_biens?.answer}
                  </WTypography>

                  <Typography color="secondary">Plan d’entretien</Typography>
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      color: entretien.Statut === 'actif' ? 'green' : 'red',
                    }}
                  >
                    {entretien.Statut}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </>
        )}
        <Box sx={{ width: '100%', typography: 'body1' }}>
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList
                onChange={handleChange}
                sx={{ '.MuiTabs-flexContainer': { overflow: 'auto' } }}
              >
                <Tab sx={{ color: 'white' }} label="Informations générales" value="1" />
                <Tab
                  onClick={() => {
                    fetchOperations()
                  }}
                  sx={{ color: 'white' }}
                  label="Oéprations à réaliser"
                  value="2"
                />
                <Tab
                  onClick={() => {
                    fetchEntretienHistoriques()
                  }}
                  sx={{ color: 'white' }}
                  label="Historiques"
                  value="3"
                />
                <Tab sx={{ color: 'white' }} label="Documents" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <WTypography variant="h6">{informationGenerales}</WTypography>
            </TabPanel>
            <TabPanel value="2">
              <WTypography variant="h6">{oeprationsRealiser}</WTypography>
            </TabPanel>
            <TabPanel value="3">{historiques}</TabPanel>
            <TabPanel value="4">{documents}</TabPanel>
          </TabContext>
        </Box>
      </Container>
    </>
  )
}
function BasicTable() {
  const siteUser = useSelector((store) => store.user)

  let params = useParams()
  const [selected, setSelected] = React.useState([])
  const [rowsPerPage, setRowsPerPage] = React.useState(20)
  const [newRows, setNewRows] = useState([])

  useEffect(() => {
    fetchOperations(params.id, 20)
  }, [])
  const fetchOperations = async (id, limit) => {
    const { data, status } = await makeGetRequest(
      `/api/Administrative/documents-operations/?PlanMaintenance=${id}`,
      {},
      true,
    )
    if (status === 200) {
      let results = data.results
      setNewRows([...results])
    }
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(rowsPerPage + 20)
    fetchOperations(params.id, rowsPerPage + 20)
  }
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name)
    let newSelected = []
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1))
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1))
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      )
    }

    setSelected(newSelected)
  }
  const deleteBulkOperations = async () => {
    if (selected.length === 0) {
      alert('Sélectionner une operation ')
    } else {
      const response = await makePostRequest(
        urls.deleteDocumentsBulkOperations,
        { selected: selected },
        {},
        true,
      )
      if (response.status === 200) {
        fetchOperations(params.id, 20)
        setSelected([])
      }
    }
  }
  return (
    <>
      <Box>
        {/* <Typography variant="h5" pl={3} pt={3} sx={{ color: 'white' }}>
          Related documents
        </Typography> */}
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }} py={5}>
        <Box>
          <Typography variant="h5" pl={1} sx={{ color: 'white' }}>
            Mes documents ({newRows.length})
          </Typography>
        </Box>
        <Box>
          <CreateDocumentsForm params={params} account="PlanMaintenance" setNewRows={setNewRows} />
          <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
        </Box>
      </Box>
      <Box sx={{ color: 'white', paddingBottom: '60px' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650, marginTop: '23px' }} size="small" aria-label="simple table">
            <TableBody>
              {newRows && newRows.length > 0 ? (
                newRows.map((row, index) => (
                  <TableRow
                    key={row.id}
                    sx={{ height: '80px', '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Checkbox
                        onClick={(event) => handleClick(event, row.id)}
                        color="primary"
                        inputProps={{
                          'aria-labelledby': index,
                        }}
                      />
                      <AttachmentIcon sx={{ padding: '0px 13px', fontSize: '45px' }} />
                      <div>
                        <Link sx={{ fontSize: '16px' }} href={row.Lien}>
                          {row.Lien.split('/').pop()}
                        </Link>
                        <br />
                        Charge le: {convertToUserDateFormate(siteUser.user, row.Datedimport)} -
                        Taille de fichier: {row.FileSize} Mio
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={3}>No data yet.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          {newRows.length > 20 ? (
            <Box display={'flex'} justifyContent={'center'}>
              <Button onClick={handleChangeRowsPerPage}>Load More</Button>
            </Box>
          ) : (
            newRows.length > 20 && (
              <Box display={'flex'} justifyContent={'center'}>
                <Button
                  onClick={() => {
                    fetchOperations(params.id, 20)
                    setRowsPerPage(20)
                  }}
                >
                  Return to initial Size
                </Button>
              </Box>
            )
          )}
        </TableContainer>
      </Box>
    </>
  )
}
